import { path } from "static-path"

export const rootPath = path("/organization")

export const createAccountPath = path("/organization/:memberInviteToken/join")
export const confirmEmailPath = path(
  "/organization/:confirmationToken/confirm-email",
)
export const signInPath = path("/organization/sign-in")
export const forgotPasswordPath = path("/organization/forgot-password")
